import { Action } from '@ngrx/store';

export const enum LocationActionTypes {
  LOAD_LOCATION = '[Location] Load Location',
  LOAD_LOCATIONS = '[Locations] Load',
  LOAD_LOCATIONS_SUCCESS = '[Locations] Load Success',
  LOAD_LOCATIONS_ERROR = '[Locations] Load Error',
  REFRESH_LOCATION = '[Locations] Refresh Locations',
}

interface LoadLocation extends Action {
  type: LocationActionTypes.LOAD_LOCATION;
  payload: any;
}

interface LoadLocations extends Action {
  type: LocationActionTypes.LOAD_LOCATIONS;
}

interface LoadLocationsSuccess extends Action {
  type: LocationActionTypes.LOAD_LOCATIONS_SUCCESS;
  payload: any;
}

interface LoadLocationsError extends Action {
  type: LocationActionTypes.LOAD_LOCATIONS_ERROR;
  payload: any;
}

interface RefreshLocation extends Action {
  type: LocationActionTypes.REFRESH_LOCATION;
}

export type LocationActions =
  | LoadLocation
  | LoadLocations
  | LoadLocationsSuccess
  | LoadLocationsError
  | RefreshLocation;
